<template lang="html">
    <div :tabindex="tabIndex" class="small-12 cell wide-btn vertical-align-middle"
         ref="button"
         :class="{ 'active': active }"
         @click="clicked"
         @keypress="clicked"
    >
      {{ buttonText }}
    </div>
</template>

<script>
  export default {
    props: {
      active: {
        type: String,
        required: false,
      },
      buttonText: {
        type: String,
        required: true,
      },
      width: {
        type: String,
        required: false,
        default: '191px',
      },
      height: {
        type: String,
        required: false,
      },
      isBold: {
        type: Boolean,
        required: false,
      },
      fontSize: {
        type: String,
        required: false,
      },
      fontColor: {
        type: String,
        required: false,
      },
      tabIndex: {
        type: Number,
        required: false,
        default: 0,
      },
    },
    methods: {
      clicked() {
        this.$emit('clicked');
      },
    },
    mounted() {
      /* get the $ref for the select element and then assign the custom styles */
      if (this.width) {
        this.$refs.button.style.width = this.width;
      }
      if (this.height) {
        this.$refs.button.style.height = this.height;
      }
      if (this.isBold) {
        this.$refs.button.style.fontWeight = 'bold';
      }
      if (this.fontSize) {
        this.$refs.button.style.fontSize = this.fontSize;
      }
      if (this.fontColor) {
        this.$refs.button.style.color = this.fontColor;
      }
    },
  };
</script>

<style lang="scss" scoped>

  /* - Sizing and layout - */

  $grid: 12px;

  /* - Colour - */

  $secondary-color: #c4cace;
  $primary-accent-color: #50e3c2;
  $focus-text-color: #4a5b68;

  .vertical-align-middle {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .atom-contents {
    height: inherit;
  }

  .wide-btn {
    border: solid 1px $secondary-color;
    border-radius: 2 * $grid;
    color: $focus-text-color;
    cursor: pointer;
    font-size: 12px;
    height: 4 * $grid;
    letter-spacing: $grid / 4;
    line-height: 2 * $grid;
    text-align: center;
    text-transform: uppercase;
  }

  .wide-btn:hover, .wide-btn.active {
    background-color: $primary-accent-color;
    border: none;
    color: #fff;
    font-weight: 600;
  }

  .wide-btn.active:hover {
    background-color: #49CCAD;
  }

</style>



// WEBPACK FOOTER //
// src/lib/rare-patternlab/src/components/buttons/RareStandardButton.vue